import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Icon} from '../Icon';
import {Text} from '../Text';
import {Flex} from '../Flex';
import styles from './PoweredByShopify.scss';
import * as locales from './locales';

type AnchorElementProps = JSX.IntrinsicElements['a'];

export interface PoweredByShopifyProps extends AnchorElementProps {
  lowlight?: boolean;
  path?: string;
}

function PoweredByShopifyComponent(props: WithI18nProps & PoweredByShopifyProps) {
  const {lowlight = false, path = 'https://www.shopify.com', i18n, ...restProps} = props;
  return (
    <a href={path} {...restProps}>
      <Flex alignItems="center">
        <Text
          type="legal"
          text={i18n.translate('label')}
          className={classNames(styles.label, lowlight ? styles.white : styles.greyLight)}
          resetMargin
        />
        <Icon
          icon="shopifyLogo"
          fill={lowlight ? 'white' : '#9aa7b1'}
          height="24"
          width="82"
          alt={i18n.translate('logoTitle')}
        />
      </Flex>
    </a>
  );
}

export const PoweredByShopify = withI18n({
  id: 'PoweredByShopify',
  fallback: locales.en,
})(PoweredByShopifyComponent);
